import { render } from "./BTable.vue?vue&type=template&id=7edff7ba"
import script from "./BTable.vue?vue&type=script&lang=js"
export * from "./BTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__